<div class="h-xl-100">
  <!-- <div class="card-header position-relative py-0 border-bottom-1">
    <ul
      class="nav nav-stretch nav-pills nav-pills-custom d-flex"
      role="tablist"
    >
      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a
          class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800 active"
          data-bs-toggle="tab"
          href="#kt_table_widget_7_tab_content_1"
          aria-selected="true"
          role="tab"
        >
          <span class="nav-text fw-semibold fs-6"> จัดการข้อมูลส่วนตัว </span>
          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"
          ></span>
        </a>
      </li>
      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a
          class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800"
          data-bs-toggle="tab"
          href="#kt_table_widget_7_tab_content_2"
          aria-selected="false"
          role="tab"
          tabindex="-1"
        >
          <span class="nav-text fw-semibold fs-6"> รหัสผ่าน </span>

          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"
          ></span>
        </a>
      </li>

      <li class="nav-item p-0 ms-0 me-10" role="presentation">
        <a
          class="nav-link btn btn-color-muted px-0 text-hover-gray-800 text-active-gray-800"
          data-bs-toggle="tab"
          href="#kt_table_widget_7_tab_content_5"
          aria-selected="true"
          role="tab"
          tabindex="-1"
        >
          <span class="nav-text fw-semibold fs-6"> เมนูผู้ปกครอง </span>

          <span
            class="bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded"
          ></span>
        </a>
      </li>
    </ul>
  </div> -->
  <!--end::Header-->

  <div class="card-body">
    <div class="tab-content mb-2">
      <div class="tab-pane fade active show" role="tabpanel">
        <app-user-profile></app-user-profile>
      </div>
    </div>
  </div>
  <!--end: Card Body-->
</div>
